import React from "react";
import { useNavigate } from "react-router";
import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";

import UserConstantsHelper from "../../helpers/constants/user";

const CardAddressMismatchModal = ({ show, message, handleClose }) => {
  const navigate = useNavigate();
  const profile = useSelector((state) => state.users.profile);

  const handleBecomePerformer = () => {
    navigate("/edit-profile");
    handleClose();
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      className={`verify light`}
    >
      <Modal.Body className="mb-4">
        <Alert variant="danger text-center">
          <Button
            variant="primary"
            className={`btn-sm red react ${
              UserConstantsHelper.isDocumentPending(profile.data)
                ? "yellow"
                : "red"
            }`}
            type="button"
          >
            <i className="fas fa-2x fa-exclamation"></i>
          </Button>
          <p>
            { message || 'The address you provided does not match address listed under your profile. To update your address, head to edit profile page.'}
          </p>
        </Alert>
      </Modal.Body>
      <div className="footer">
        <Button variant="default" onClick={handleClose}>
          Close
        </Button>
        
        <Button
            variant="default"
            type="submit"
            onClick={handleBecomePerformer}
          >
            Edit profile
        </Button>
      </div>
    </Modal>
  );
};

export default CardAddressMismatchModal;
